import memoize from 'memoize-one';
import type { IntlShape } from 'react-intl';

import { OptionType } from '@atlaskit/select';

import { MergeStrategy, SyncStrategy } from 'src/types/pull-request';

import { messages } from './merge-strategies.i18n';

export type MergeStrategyOption = OptionType & {
  description: string;
  value: MergeStrategy;
};

export type SyncStrategyOption = OptionType & {
  description: string;
  value: SyncStrategy;
};

const getStrategy = (
  strategy: MergeStrategy | SyncStrategy,
  intl: IntlShape
): MergeStrategyOption | SyncStrategyOption | undefined => {
  switch (strategy) {
    case MergeStrategy.MergeCommit:
      return {
        label: intl.formatMessage(messages.mergeCommit),
        value: MergeStrategy.MergeCommit,
        description: 'git merge --no-ff',
      };
    case MergeStrategy.Squash:
      return {
        label: intl.formatMessage(messages.squash),
        value: MergeStrategy.Squash,
        description: 'git merge --squash',
      };
    case MergeStrategy.FastForward:
      return {
        label: intl.formatMessage(messages.fastForward),
        value: MergeStrategy.FastForward,
        description: 'git merge --ff-only',
      };
    case MergeStrategy.SquashFastForward:
      return {
        label: intl.formatMessage(messages.squashFastForward),
        value: MergeStrategy.SquashFastForward,
        description: 'git merge --squash --ff-only',
      };
    case MergeStrategy.RebaseFastForward:
      return {
        label: intl.formatMessage(messages.rebaseFastForward),
        value: MergeStrategy.RebaseFastForward,
        description: 'git rebase; git merge --ff-only',
      };
    case MergeStrategy.RebaseMerge:
      return {
        label: intl.formatMessage(messages.rebaseMerge),
        value: MergeStrategy.RebaseMerge,
        description: 'git rebase; git merge --no-ff',
      };
    case SyncStrategy.MergeCommit:
      return {
        label: 'Merge commit',
        value: SyncStrategy.MergeCommit,
        description: 'git merge --no-ff',
      };
    case SyncStrategy.Rebase:
      return {
        label: 'Rebase',
        value: SyncStrategy.Rebase,
        description: 'git rebase',
      };
    default:
      return undefined;
  }
};

export const getStrategyOption = memoize(getStrategy);
